const FIELD_LABELS: Record<string, string> = { display_name: 'Display name', description: 'Description' }

interface ValidationIssue {
  loc?: unknown[]
  msg?: unknown
}

/** The message for an error body: the portal's `detail.message`, or the first of FastAPI's validation issues. */
export function apiErrorMessage(body: unknown, fallback: string): string {
  const detail = (body as { detail?: unknown } | null)?.detail
  if (Array.isArray(detail) && detail.length > 0) {
    const issue = detail[0] as ValidationIssue
    if (typeof issue.msg === 'string' && issue.msg !== '') {
      const field = issue.loc?.[issue.loc.length - 1]
      const label = typeof field === 'string' ? FIELD_LABELS[field] : undefined
      const message = issue.msg.replace(/^Value error, /, '')
      return label ? `${label}: ${message}` : message
    }
  }
  const message = (detail as { message?: unknown } | null | undefined)?.message
  return typeof message === 'string' && message !== '' ? message : fallback
}
